module.exports = __webpack_public_path__ + "img/鹏爱.dbb1e0c.png";